import TenantConfig from '@framework/tenant/TenantConfig';
import Logger from '@framework/sentry/Logger';

export const getTrackingIdGoogleTagManager = () => {
  const tenantConfig = TenantConfig.fromHostname();

  if (!tenantConfig) {
    return undefined;
  }

  if (!tenantConfig.gtm) {
    Logger.error({ message: 'GTM part of tenant config not found.', context: { tenantConfig } });
    return undefined;
  }

  return tenantConfig.gtm.trackingId;
};

export const getTrackingIdGoogleAnalytics = () => {
  const tenantConfig = TenantConfig.fromHostname();

  if (!tenantConfig) {
    return undefined;
  }

  if (!tenantConfig.ga) {
    Logger.error({ message: 'GA part of tenant config not found.', context: { tenantConfig } });
    return undefined;
  }

  return tenantConfig.ga.trackingId;
};
